import CloseIcon from "../../assets/images/x.svg";
import { ExternalLink } from "../../components";
import Meeting from "../../components/icons/Meeting";
import { useState } from "react";

const StudentDetailModal = ({ isOpen, handleClose, studentData, openLearningSpaceForStudent }) => {
  const [copied, setCopied] = useState(false);

  if (!isOpen) return null;

  const {
    First_Name,
    Last_Name,
    Guardian_First_Name,
    Guardian_Last_Name,
    Student_Language,
    District_Text,
    grade,
    Program_Type,
    First_Matched_Date_from_Matched,
    Availability,
    Tutoring_Code,
    information,
  } = studentData;

  // const datesOfSessions = Dates_of_sessions[0]?.split(",");

  return (
    <>
      <div
        className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex items-center justify-center"
        onClick={handleClose}>
        <div
          className="bg-white rounded-3xl shadow-lg w-full max-w-[536px] transform transition-all duration-300 relative"
          onClick={(e) => e.stopPropagation()}>
          <div className="h-[80vh] overflow-y-auto p-10 pb-20">
            <button
              className="absolute right-[10px] top-[10px] w-10 h-10 rounded-full flex items-center justify-center"
              onClick={handleClose}>
              <img src={CloseIcon} alt="Close Icon" />
            </button>
            <div className="pb-4">
              <h1 className="text-xl text-center font-bold text-titleColor">
                {First_Name} {Last_Name}
              </h1>
              {Guardian_First_Name && Guardian_Last_Name && (
                <p className="text-[#5B5B5B] font-medium text-center">
                  Guardian: {Guardian_First_Name} {Guardian_Last_Name}
                </p>
              )}
            </div>
            <div className="py-4 border-t border-[#E7E5E4]">
              <h4 className="text-[#292524] font-semibold mb-2">Student Information</h4>
              <div className="flex items-center gap-2 pb-1">
                <Meeting />
                <span className="text-sm text-stone">
                  {"https://student-portal.stepuptutoring.org/student/" + Tutoring_Code}
                </span>
                <button
                  className="ml-1 p-1 rounded-md hover:bg-gray-100 transition-colors"
                  onClick={() => {
                    navigator.clipboard.writeText("https://student-portal.stepuptutoring.org/student/" + Tutoring_Code);
                    setCopied(true);
                    setTimeout(() => setCopied(false), 2000);
                  }}
                  title="Copy link">
                  {copied ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="text-green-500">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="text-gray-500">
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                    </svg>
                  )}
                </button>
              </div>
              <ul className="list-disc pl-4">
                {Student_Language && (
                  <li className="text-sm text-stone">
                    Preferred Language of Guardian: <span className="font-bold">{Student_Language}</span>
                  </li>
                )}
                {District_Text && (
                  <li className="text-sm text-stone">
                    District: <span className="font-bold">{District_Text}</span>
                  </li>
                )}
                {grade && (
                  <li className="text-sm text-stone">
                    Grade Level: <span className="font-bold">{grade}</span>
                  </li>
                )}
                {Program_Type && (
                  <li className="text-sm text-stone">
                    Program Type: <span className="font-bold">{Program_Type}</span>
                  </li>
                )}
                {First_Matched_Date_from_Matched && (
                  <li className="text-sm text-stone">
                    Matched Date:{" "}
                    <span className="font-bold">{new Date(First_Matched_Date_from_Matched).toLocaleDateString()}</span>
                  </li>
                )}
                {Availability && (
                  <li className="text-sm text-stone">
                    Availability: <span className="font-bold">{Availability}</span>
                  </li>
                )}
                {information && Object.entries(information).map(([key, value]) => {
                  // Skip fields that are already displayed from the main studentData
                  const skipFields = [
                    "District",
                    "Grade Level",
                    "Program Type",
                    "Matched Date",
                    "Availability",
                    "Preferred Language of Guardian"
                  ];
                  
                  if (skipFields.includes(key)) {
                    return null;
                  }
                  
                  return (
                    <li key={key} className="text-sm text-stone">
                      {key}: <span className="font-bold">{value}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
            {/* <div className="py-4 border-t border-[#E7E5E4]">
              <h4 className="text-[#292524] font-semibold mb-2">Match Information</h4>
              <ul className="list-disc pl-4 ">
                <li className="text-sm text-stone">
                  Matched Date: <span className="font-bold">{new Date(First_Matched_Date_from_Matched).toLocaleDateString()}</span>
                </li>
                <li className="text-sm text-stone">
                  # Meetings: <span className="font-bold">{datesOfSessions ? datesOfSessions.length : 0}</span>
                </li>
                <li className="text-sm text-stone">
                  Meeting time <span className="font-bold"></span>
                </li>
                <li className="text-sm text-stone">
                  Last Meeting <span className="font-bold">{datesOfSessions && datesOfSessions.length > 0
      ? new Date(datesOfSessions.sort((a, b) => new Date(b) - new Date(a))[0]).toLocaleDateString()
      : "N/A"}</span>
                </li>
              </ul>
            </div> */}
            <div className="fixed bottom-0 left-0 w-full p-4 border-t border-[#E5E7EB] bg-[#F3F4F6] flex items-center justify-end rounded-bl-3xl rounded-br-3xl gap-2">
              <ExternalLink
                href="https://airtable.com/appVTwOTC6wauyLBL/shrNNQzXOJOP7WtEm"
                className="px-3 py-[10px] bg-whit leading-4 text-titleColor bg-white text-sm font-medium border border-solid border-[#E5E7EB] rounded-md hover:opacity-60">
                Submit an update
              </ExternalLink>
              <button
                onClick={() => {
                  openLearningSpaceForStudent();
                  handleClose();
                }}
                className="px-3 py-[10px] leading-4 bg-teal font-medium text-sm text-white border border-solid border-teal rounded-md hover:opacity-60">
                Join Meeting
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentDetailModal;
